var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": ".98rem" } },
    [
      _c("topbar", { attrs: { text: "测试" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "testBox" },
        [
          _vm._l(_vm.scaleInfoList, function(item) {
            return _c(
              "div",
              {
                staticClass: "testItem",
                on: {
                  click: function($event) {
                    _vm.to("testDetail?scaleId=" + item.scaleId)
                  }
                }
              },
              [
                _c("div", { staticClass: "leftBox" }, [
                  _c(
                    "div",
                    {
                      staticClass: "picBox",
                      style: {
                        background:
                          "url(" +
                          _vm.EnvUrl +
                          item.pic +
                          ") no-repeat center/cover"
                      }
                    },
                    [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(_vm._s(item.labelName))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mainBox" }, [
                    _c("div", { staticClass: "testTitle" }, [
                      _vm._v(_vm._s(item.title))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "titleContent" }, [
                      _vm._v(_vm._s(item.tagline))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "numBox" }, [
                      _vm._v(
                        _vm._s(item.testCount) +
                          "人已测\n                        "
                      ),
                      _c("div", { staticClass: "rightBox" }, [
                        _vm._v("立即开始")
                      ])
                    ])
                  ])
                ])
              ]
            )
          }),
          _vm._v(" "),
          _c("no-more-data", { attrs: { noMoreData: _vm.noMoreData } })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce641740", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce641740","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/testList.vue
// module id = null
// module chunks = 